import { createVanIconComponent } from "./van"

const PhotoOutlined = createVanIconComponent("photo-o")
export default PhotoOutlined
